import React from 'react';
import Isvg from 'react-inlinesvg';
import { defineMessages, injectIntl } from 'react-intl';
import { pick, omit } from 'helpers/object';
import { DESIGN_SYSTEM_ICONS } from 'constants/icons';
import { KeywordSearchBoxPanel } from './KeywordSearchBoxPanel';
import { SearchBoxField } from './SearchBoxField';

const itemToString = i => (i ? i.name : '').replace(/<[^>]*>/g, '');

const messages = defineMessages({
  placeholder: {
    id: 'search.searchbox.keywordField.placeholder',
    defaultMessage: 'Find a studio or activity',
  },
});

export const KeywordFieldUnwrapped = props => {
  const { intl } = props;
  return (
    <SearchBoxField
      {...pick(Object.keys(SearchBoxField.propTypes), props)}
      isClearable
      itemToString={itemToString}
      icon={<Isvg src={DESIGN_SYSTEM_ICONS.lookingGlass} />}
      placeholder={intl.formatMessage(messages.placeholder)}>
      {({ getItemProps, highlightedIndex, onPanelScroll }) => (
        <KeywordSearchBoxPanel
          {...pick(Object.keys(KeywordSearchBoxPanel.propTypes), props)}
          getItemProps={getItemProps}
          highlightedIndex={highlightedIndex}
          onPanelScroll={onPanelScroll}
        />
      )}
    </SearchBoxField>
  );
};

KeywordFieldUnwrapped.propTypes = {
  ...omit(['getItemProps'], KeywordSearchBoxPanel.propTypes),
  ...omit(['prompt', 'itemToString', 'children', 'placeholder'], SearchBoxField.propTypes),
};

export const KeywordField = injectIntl(KeywordFieldUnwrapped);
